// Web port of mobile/src/utils/reportSections.ts — the 7 editable report
// sections shared by the report builder and the settings editor.

export const EMPTY_TEMPLATE = {
  cover_letter: "",
  executive_summary: "",
  scope_of_works: "",
  methodology: "",
  recommendations: "",
  company_terms: "",
  disclaimer: "",
};

export const SECTION_DEFS = [
  {
    key: "cover_letter",
    label: "Cover Letter",
    hint: "Opening greeting and context placed at the top of the report.",
    placeholder: "Dear [Client Name],\n\nPlease find enclosed our fire door inspection report for...",
  },
  {
    key: "executive_summary",
    label: "Executive Summary",
    hint: "Short overview of the inspection scope, findings and outcome.",
    placeholder: "This audit covers all FD30 communal doors at…",
  },
  {
    key: "scope_of_works",
    label: "Scope of Works",
    hint: "What was inspected (and what was not). Helps set client expectations.",
    placeholder: "In line with BS 8214 we inspected…",
  },
  {
    key: "methodology",
    label: "Methodology Statement",
    hint: "How the inspection was performed — 12-point gap checks, photo evidence, etc.",
    placeholder: "Each door was assessed against the 16-point checklist drawn from BS 8214:2026…",
  },
  {
    key: "recommendations",
    label: "Recommendations",
    hint: "Suggested next steps for the client (remedials, re-inspection cadence).",
    placeholder: "We recommend replacing failed seals within 14 days and re-inspecting after remedial works…",
  },
  {
    key: "company_terms",
    label: "Company Terms",
    hint: "Standard commercial terms (payment, validity, liability).",
    placeholder: "Payment terms: 30 days net.\nQuotations are valid for 30 days from issue…",
  },
  {
    key: "disclaimer",
    label: "Disclaimer",
    hint: "Limitation of liability / inspection-was-visual-only style notice.",
    placeholder: "This report is based on visual inspection only at the time of survey. Concealed defects may not have been identified.",
  },
];
